import styled from 'styled-components';

export const StyledCookieBanner = styled.div`
  position: fixed;
  left: 16px;
  bottom: 16px;
  z-index: 100;
  margin: 0;
  display: ${props => (props.isOpen ? 'inline-flex' : 'none')};
  flex-direction: column;
  align-items: flex-start;
  max-width: 296px;
  border: 1px solid ${props => props.theme.colors.border.fur};
  box-shadow: ${props => props.theme.spacing(0, 1, 3, 0)} rgba(0, 0, 0, 0.1);
  border-radius: ${props => props.theme.spacing(2)};
  background: ${props => props.theme.colors.background.lightest};
  padding: ${props => props.theme.spacing(6)};
  gap: ${props => props.theme.spacing(2)};
  @media ${props => props.theme.tablet} {
    min-width: 672px;
    max-width: 672px;
  }
`;

export const Heading = styled.p`
  ${props => props.theme.typography.bodyBold}
`;

export const Subheading = styled.p`
  ${props => props.theme.typography.body};
  max-width: 482px;
`;

export const BottomRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${props => props.theme.spacing(4)};
  @media ${props => props.theme.tablet} {
    flex-direction: row;
    align-items: center;
  }
`;

export const LinksContainer = styled.div`
  color: ${props => props.theme.colors.text.primary};

  a {
    color: ${props => props.theme.colors.text.primary};
    ${props => props.theme.typography.body}
  }
`;
